import { render } from "./BettingSavedTable.vue?vue&type=template&id=400d723d&scoped=true"
import script from "./BettingSavedTable.vue?vue&type=script&lang=js"
export * from "./BettingSavedTable.vue?vue&type=script&lang=js"

import "./BettingSavedTable.vue?vue&type=style&index=0&id=400d723d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400d723d"]])

export default __exports__